module.exports = __webpack_public_path__ + "img/icon_db_3.332513c6.svg";